import $ from 'jquery';
import autosize from 'autosize';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import { closest } from 'next/javascripts/modules/dom';

import 'next/stylesheets/components/todo-inline-form.scss';

let lastAssignee = null;
let lastDate = null;

function parseDate(dates) {
  let startAt;
  let dueAt;
  if (dates.length === 2) {
    [startAt, dueAt] = dates;
  } else {
    startAt = null;
    [dueAt] = dates;
  }
  return [startAt, dueAt];
}

Component('tr-todo-inline-form', {
  mixins: [eventListenerMixin],

  properties: {
    creation: {
      type: Boolean,
      default: true,
    },

    submitting: {
      type: Boolean,
      default: false,
    },

    plugins: {
      type: Array,
      default: [],
    },

    rememberLastAssignee: {
      type: Boolean,
      default: false,
    },

    rememberLastDate: {
      type: Boolean,
      default: false,
    },
  },

  ready() {
    this.contentInput = this.querySelector('.todo-content-form-input textarea');

    this.initAutosize();
    this.initRemeberValue();

    this.listenTo(this.contentInput, {
      compositionstart: () => { this.isInputComposing = true; },
      compositionend: () => { this.isInputComposing = false; },
      keydown: this.handleContentKeydown.bind(this),
    });
    this.listenTo(document, 'click', this.handleClick.bind(this));
    this.listenTo(this, {
      'tr-todo-assignee-select-field:change': this.handleAssigneeChanged.bind(this),
      'tr-todo-date-field:change': this.handleDateChange.bind(this),
    });
  },

  initAutosize() {
    this.contentInput.rows = 1;
    autosize(this.contentInput);
    this.contentInput.focus();

    const { length: selectionOffset } = this.contentInput.value;
    this.contentInput.setSelectionRange(selectionOffset, selectionOffset);
  },

  initRemeberValue() {
    if (!this.creation) return;
    const assignee = this.querySelector('tr-todo-assignee-select-field');
    if (assignee && this.rememberLastAssignee && lastAssignee) {
      assignee.setValue(lastAssignee);
    }
    const date = this.querySelector('tr-todo-date-field');
    if (date && this.rememberLastDate && lastDate) {
      date.setValue(lastDate);
      this.setDate(lastDate);
    }
  },

  handleClick(event) {
    const { target } = event;
    if (this.contains(target) || closest(target, '.mdc-menu-surface')) return;
    this.submit();
  },

  handleContentKeydown(event) {
    if (this.isInputComposing || event.isComposing || event.keyCode === 229) return;

    const isEnter = event.key === 'Enter' || event.keyCode === 13;
    const isEscape = event.key === 'Escape' || event.keyCode === 27;

    if (isEnter) {
      event.preventDefault();
      event.stopPropagation();

      if (event.ctrlKey || event.metaKey) {
        this.contentInput.value = `${this.contentInput.value}\n`;
        autosize.update(this.contentInput);
      } else {
        this.submit();
      }
    } else if (isEscape) {
      event.stopPropagation();
      this.contentInput.value = '';
      this.remove();
    }
  },

  handleAssigneeChanged(event) {
    event.stopPropagation();
    if (this.rememberLastAssignee) lastAssignee = event.detail;
  },

  handleDateChange(event) {
    event.stopPropagation();

    const dates = event.detail;
    if (this.rememberLastDate) lastDate = dates;
    this.setDate(dates);
  },

  setDate(dates) {
    let startAt = null;
    let dueAt = null;
    if (dates.length) [startAt, dueAt] = parseDate(dates.split(','));
    const start = this.querySelector('[name*=start_at]');
    if (start) start.value = startAt;
    const due = this.querySelector('[name*=due_at]');
    if (due) due.value = dueAt;
  },

  submit() {
    if (this.submitting) return;
    const { value } = this.contentInput;
    if (value) {
      this.submitting = true;
      $(this.querySelector('.tr-form')).trigger('submit');
    } else {
      this.remove();
    }
  },

  disconnected() {
    this.submitting = false;
    this.stopListening();
  },
});
